module.exports = __webpack_public_path__ + "static/media/logowhite.5ef1ef48.svg";